import APP_ACTIONS from '../constants/app-actions';

const initialState = {
    availableMunicipalities: {},
    currentMunicipality: undefined,
    isMunicipalityPromptModalOpen: false,
};

const municipality = (state = initialState, action) => {
    if (action.type === APP_ACTIONS.SET_AVAILABLE_MUNICIPALITIES) {
        return {
            ...state,
            availableMunicipalities: action.payload,
        };
    }
    if (action.type === APP_ACTIONS.SET_CURRENT_MUNICIPALITY) {
        return {
            ...state,
            currentMunicipality: action.payload,
        };
    }
    if (action.type === APP_ACTIONS.SET_IS_MUNICIPALITY_PROMPT_MODAL_OPEN) {
        return {
            ...state,
            isMunicipalityPromptModalOpen: action.payload,
        };
    }
    return state;
};

export default municipality;



/** WEBPACK FOOTER **
 ** ./src/reducers/municipality.js
 **/